import { render, staticRenderFns } from "./HomeCbm.vue?vue&type=template&id=b6544e60&scoped=true"
import script from "./HomeCbm.vue?vue&type=script&lang=js"
export * from "./HomeCbm.vue?vue&type=script&lang=js"
import style0 from "./HomeCbm.vue?vue&type=style&index=0&id=b6544e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6544e60",
  null
  
)

export default component.exports